import React from 'react';
import {
  FormGroup, Label, Input, Modal, ModalHeader, ModalBody, Form, ButtonGroup, Button,
}
  from 'reactstrap';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import {
  INVITE_ICON, validationMessages, regexPattern, staticConstants,
} from '../../utils';
import InputError from '../shared/elments/InputError';


function Invitation(props) {
  const { isOpen: modal, role } = props;
  const onClose = () => {
    props.onClose(false);
  };
  const { register, handleSubmit, errors } = useForm({ mode: 'onBlur', nativeValidation: false });

  const onSubmit = (data) => {
    props.submitCallBack(data);
  };
  return (
    <Modal isOpen={modal} onClose={onClose} className="modal-invite modal-dialog-centered" keyboard={false}>
      <ModalHeader toggle={onClose} className="modal-blank-header" />
      <ModalBody>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <img
            src={INVITE_ICON}
            alt="Invite"
          />
          {role === staticConstants.ROLE.ARTIST && (
          <>
            <h3>Invite a label</h3>
            <p>Your label can now be a part of BYGmusic, you can invite by email address.</p>
          </>
          )}
          {role === staticConstants.ROLE.MANAGER && (
          <>
            <h3>Invite a artist</h3>
            <p>Your artist can now be a part of BYGmusic, you can invite by email address.</p>
          </>
          )}

          <FormGroup className={errors.email ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
            <Label
              for="Email"
            >
              Email address
            </Label>
            <Input
              type="email"
              name="email"
              placeholder="Enter email address"
              innerRef={register({
                required: true,
                type: 'email',
                pattern: { value: regexPattern.EMAIL, message: validationMessages.EMAIL },
              })}
            />
            <InputError error={errors.email} />
          </FormGroup>
          <ButtonGroup className="justify-content-center">
            <Button
              color="primary"
              element="inlineBlock"
              type="submit"
              className="btn-md"
            >
              Send invite
            </Button>
          </ButtonGroup>
        </Form>
      </ModalBody>
    </Modal>


  );
}
Invitation.propTypes = {
  role: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  submitCallBack: PropTypes.func.isRequired,
};
export default Invitation;
